import { render } from "./baseicon.vue?vue&type=template&id=26be69b9"
import script from "./baseicon.vue?vue&type=script&lang=js"
export * from "./baseicon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__